var div = null;
const reg = /[a-zA-Z0-9\W]/;
export default {
  install(Vue) {
    Vue.filter("htmlJustify", function (v) {
      var arr = v.split("");
      if (!div) {
        div = document.createElement("div");
      }
      div.innerHTML = v;
      if (div?.childNodes?.length) {
        deepNodes(div, replaceNodeText);
        let html =
          div.childNodes[0].nodeType == 1
            ? div.childNodes[0].outerHTML
            : div.childNodes[0].nodeValue;
        div.innerHTML = "";
        return html;
      }
      return "";
    });
  }
};
function deepNodes(node, callback) {
  if (node.nodeType == 3) {
    callback && callback(node);
  }
  if (node?.childNodes?.length) {
    node.childNodes.forEach((it) => {
      deepNodes(it, callback);
    });
  }
}
function replaceNodeText(node) {
  let value = node.nodeValue;
  const arr = value.split("");
  const newValue = arr.map((it, i) => {
    reg.lastIndex = 0;
    return reg.test(it) && i < arr.length - 1 ? `${it}&nbsp;` : it;
  });
  node.nodeValue = newValue.join("");
}
